// import { Platform } from 'quasar'

const routes = [
  {
    path: '/',
    component: () => import('layouts/home-layout.vue'),
    children: [
      {
        path: '',
        name: 'home-selection',
        component: () => import('pages/home-selection.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'activate',
        name: 'activate',
        component: () => import('pages/login/activate-page.vue'),
        meta: {
          auth: false
        }
      }
    ]
  },
  {
    path: '/auth',
    component: () => import('layouts/auth-layout.vue'),
    children: [
      {
        path: '',
        name: 'login-form',
        component: () => import('pages/login/login-form.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'email-recover',
        name: 'email-recover',
        component: () => import('pages/login/recover-email.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'code-verification',
        name: 'code-verfication',
        component: () => import('pages/login/verify-code.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'change-password',
        name: 'change-password',
        component: () => import('pages/login/change-password.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'register-form',
        name: 'register-form',
        component: () => import('pages/login/register-form.vue'),
        meta: {
          auth: false
        }
      }
    ]
  },
  {
    path: '/:vehicleType',
    component: () => import('layouts/main-layout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('pages/Index.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'search',
        component: () => import('pages/search/search.vue'),
        children: [
          {
            name: 'brand',
            path: '',
            component: () => import('pages/search/brands.vue')
          },
          {
            name: 'models',
            path: ':brand',
            component: () => import('pages/search/models.vue')
          },
          {
            name: 'years',
            path: ':brand/:model',
            component: () => import('pages/search/years.vue')
          },
          {
            name: 'version',
            path: ':brand/:model/:year',
            component: () => import('pages/search/version.vue')
          }
        ]
      },
      {
        path: 'tyres',
        name: 'tyres',
        component: () => import('pages/tyres/index.vue')
      },
      {
        path: 'tyres/:id',
        name: 'tyre-detail',
        component: () => import('pages/tyres/detail.vue')
      },
      {
        path: 'tyre-family',
        name: 'tyre-family',
        component: () => import('pages/tyre-family/index.vue')
      },
      {
        path: 'tyre-family/:name',
        name: 'tyre-family-view',
        component: () => import('pages/tyre-family/view')
      },
      {
        path: 'rims',
        name: 'rims',
        component: () => import('pages/rims/index.vue')
      },
      {
        path: 'mspn',
        name: 'mspn',
        component: () => import('pages/mspn/index.vue')
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('pages/news/index.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'news/:id',
        name: 'news-view',
        component: () => import('pages/news/view'),
        meta: {
          auth: false
        }
      },
      {
        path: 'application',
        name: 'application',
        component: () => import('pages/application/application.vue')
      },
      {
        path: 'categories',
        name: 'categories',
        component: () => import('pages/categories/categories.vue')
      },
      {
        path: 'technologies',
        name: 'technologies',
        component: () => import('pages/technologies/index.vue')
      },
      {
        path: 'technologies/:id',
        name: 'technologies-view',
        component: () => import('pages/technologies/technologies-view.vue')
      },
      {
        path: 'courses',
        name: 'courses',
        component: () => import('pages/courses/courses-page.vue')
      },
      {
        path: 'courses/:id',
        name: 'courses-detail',
        component: () => import('pages/courses/courses-detail-page.vue')
      },
      {
        path: 'courses/:id/test',
        name: 'courses-test',
        component: () => import('pages/courses/courses-test-page.vue')
      }
    ]
  }
]

/* if (Platform.is.ios) {
  routes[0].children.push({
    path: '/performance-calculator/',
    name: 'performance-calculator',
    component: () => import('pages/performance-calculator/index'),
    meta: {
      auth: false
    }
  })
} */

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/error-404.vue')
  })
}

export default routes
